import { useDispatch, useSelector } from 'react-redux';
import Select from "react-select";
import * as actions from '../../actions/dashboardactions'


const MultiSelectDropdown = ({ inputOptions, selectedOptions }) => {
    const state = useSelector((state) => state.dashboardReducer);    
    const dispatch = useDispatch();

    const handleChange = (selected) => {
        dispatch(actions.saveDropDownValues(selected))       
    };

    return (
        <Select
            options={inputOptions}
            isMulti
            value={selectedOptions}
            onChange={handleChange}
            placeholder="All agents"
            styles={{
                control: (provided) => ({
                  ...provided,
                  width: "500px",
                  minHeight: "10px",
                }),
              }}            
            closeMenuOnSelect={false}
        />
    );
};


export default MultiSelectDropdown;
